import React, { useEffect, useState } from "react";
import "../../../App.css";
import { getBusinessDetails, updateBusiness } from "../../../services/settings";
import toast from "react-hot-toast";
import { useAuth } from "../../../context/AuthContextProvider";
import { useQueryClient } from "@tanstack/react-query";

const AboutBusiness = () => {
  const [businessDetails, setBusinessDetails] = useState({});
  const [loading, setLoading] = useState("");
  const [merchantId, setMerchantId] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [businessWebAddress, setBusinessWebAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [supportPhoneNumber, setSupportPhoneNumber] = useState("");
  const [supportEmail, setSupportEmail] = useState("");
  const [chargeBackEmail, setChargeBackEmail] = useState("");
  const { globalProfile } = useAuth();
  const queryClient = useQueryClient();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await updateBusiness(
        {
          businessEmailAddress: businessEmail,
          businessPhoneNumber: phoneNumber,
          businessAddress: address,
          businessWebAddress,
          supportPhoneNumber: supportPhoneNumber,
          supportEmail: supportEmail,
          chargeBackEmailAddress: chargeBackEmail,
          country: country,
        },
        merchantId
      );

      toast.success(response.message);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
        setLoading(false);
      }
    }
  };

  const handleBusinessDetails = async () => {
    try {
      const res = await getBusinessDetails();
      setBusinessDetails(res.data);
      setMerchantId(res.data.merchantId); // Update state variables with profileInfo data
      setBusinessName(res.data.businessName);
      setBusinessEmail(res.data.businessEmail);
      setBusinessWebAddress(res.data.webAddress);
      setPhoneNumber(res.data.phoneNumber);
      setAddress(res.data.address);
      setSupportPhoneNumber(res.data.supportPhoneNumber);
      setSupportEmail(res.data.supportEmail);
      setChargeBackEmail(res.data.chargeBackEmail);
      setCountry(res.data.country);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    handleBusinessDetails();
  }, [globalProfile]);

  return (
    <div className="md:pl-[1.8rem] min-h-screen relative">
      <form onSubmit={handleSubmit}>
        <section className="xl:w-[716px] w-full mt-[1.5rem] grid lg:grid-cols-2 gap-x-[7rem] gap-2">
          <div className="flex flex-col pt-4 px-3 md:px-0">
            <label>Business Name</label>
            <input
              // placeholder="Update username"
              value={businessName}
              type="text"
              disabled
              className="xl:w-[348px] w-72 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
            />
            <input />
          </div>

          <div className="flex flex-col pt-4 px-3 md:px-0">
            <label>Business Address</label>
            <input
              // placeholder="Update full address"
              value={address}
              type="text"
              className="xl:w-[348px] w-72 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="flex flex-col pt-4 px-3 md:px-0">
            <label>Business Phone Number</label>
            <input
              // placeholder="Update business phone number"
              value={phoneNumber}
              type="text"
              className="xl:w-[348px] w-72 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>
          <div className="flex flex-col pt-4 px-3 md:px-0">
            <label>Business Email Address</label>
            <input
              // placeholder="Update business email address"
              value={businessEmail}
              type="text"
              className="xl:w-[348px] w-72 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              onChange={(e) => setBusinessEmail(e.target.value)}
            />
          </div>

          <div className="flex flex-col pt-4 px-3 md:px-0">
            <label>Support Phone Number</label>
            <input
              // placeholder="Update support phone number"
              value={supportPhoneNumber}
              type="text"
              className="xl:w-[348px] w-72 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              onChange={(e) => setSupportPhoneNumber(e.target.value)}
            />
          </div>
          <div className="flex flex-col pt-4 px-3 md:px-0">
            <label>Support Email Address</label>
            <input
              // placeholder="Update support email address"
              value={supportEmail}
              type="text"
              className="xl:w-[348px] w-72 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              onChange={(e) => setSupportEmail(e.target.value)}
            />
          </div>
          <div className="flex flex-col pt-4 px-3 md:px-0">
            <label>Country</label>
            <input
              // placeholder="Update Country"
              value={country}
              type="text"
              className="xl:w-[348px] w-72 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              onChange={(e) => setCountry(e.target.value)}
            />
          </div>

          <div className="flex flex-col pt-4 px-3 md:px-0">
            <label>Chargeback Email Address</label>
            <input
              // placeholder="Update chargeback email address"
              value={chargeBackEmail}
              type="text"
              className="xl:w-[348px] w-72 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              onChange={(e) => setChargeBackEmail(e.target.value)}
            />
          </div>

          <div className="flex flex-col pt-4 px-3 md:px-0">
            <label>Business Web Address</label>
            <input
              // placeholder="Update chargeback email address"
              value={businessWebAddress}
              type="text"
              className="xl:w-[348px] w-72 h-[50px]  bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              onChange={(e) => setBusinessWebAddress(e.target.value)}
            />
          </div>

          <div className="xl:w-[337px] flex flex-col gap-5 pt-8">
            <p className="text-[20px] font-[400]">
              Who should pay the transaction fee?
            </p>
            <div>
              {" "}
              <label
                className="container"
                style={{ fontSize: "14px", fontWeight: 400 }}
              >
                Make customers pay the transaction fees
                <input type="radio" name="fees" />
                <span className="checkmark"></span>
              </label>
              <label
                className="container"
                style={{ fontSize: "14px", fontWeight: 400 }}
              >
                Charge me for the transaction fees
                <input type="radio" name="fees" />
                <span className="checkmark"></span>
              </label>
            </div>
          </div>

          <div className="flex flex-col md:w-[352px] gap-5 ">
            <p className="text-[20px]  font-[400]">
              How do you want to get your earnings?
            </p>
            <div>
              {" "}
              <label
                className="container"
                style={{ fontSize: "14px", fontWeight: 400 }}
              >
                Settle to my bank account <input type="radio" name="earnings" />
                <span className="checkmark"></span>
              </label>
              <label
                className="container"
                style={{ fontSize: "14px", fontWeight: 400 }}
              >
                Settle to my payout balance{" "}
                <input type="radio" name="earnings" />
                <span className="checkmark"></span>
              </label>
            </div>
          </div>
          <div></div>

          <div className=" px-3 md:px-0">
            <button
              className="md:w-[272px] w-72 mb-10 h-[42px] rounded-[8px] text-white bg-primary"
              type="submit"
            >
              Update
            </button>
          </div>
        </section>
      </form>
    </div>
  );
};

export default AboutBusiness;
